export const EVENT_TYPES = {
  leave: 'leave',
  sickCallout: 'sick_callout',
  shift: 'shift',
  noShow: 'no_show',
  availableShift: 'available',
  unavailability: 'availability',
  unassignedShift: 'unassigned',
  offeredToMe: 'offeredToMe',
  pending: 'pending_admin_event',
};

export const UNAVAILABILITY = 'unavailability';

export const navigationTabs = {
  employee: [
    {
      label: 'My schedule',
      value: 'myschedule',
      myEvents: true,
      isCalendar: true,
    },
    {
      label: 'Full schedule',
      value: 'fullschedule',
      filter: {
        eventTypes: [
          EVENT_TYPES.shift,
          EVENT_TYPES.leave,
          EVENT_TYPES.unavailability,
          EVENT_TYPES.noShow,
          EVENT_TYPES.sickCallout,
        ],
      },
      isCalendar: true,
    },
    {
      label: 'Available shifts',
      value: 'availableshifts',
      myLocations: false,
      myPositions: false,
      filter: {
        eventTypes: [EVENT_TYPES.availableShift, EVENT_TYPES.offeredToMe],
      },
      isCalendar: true,
    },
    {
      label: 'Unavailability',
      value: 'availability',
      isCalendar: true,
      myEvents: true,
    },
    {
      label: 'Experimental',
      value: 'experimental',
      isCalendar: true,
    },
  ],
  manager: [
    {
      label: 'Full schedule',
      value: 'alllocations',
      isCalendar: true,
    },
    {
      label: 'My locations',
      value: 'mylocations',
      myLocations: true,
      isCalendar: true,
    },
    {
      label: 'My schedule',
      value: 'myschedule',
      filter: {
        eventTypes: Object.values(EVENT_TYPES).filter((t) => t !== EVENT_TYPES.unassignedShift),
      },
      myLocations: true,
      myPositions: true,
      myEvents: true,
      isCalendar: true,
    },
    {
      label: 'Pending approval',
      value: 'pendingapproval',
      filter: {
        eventTypes: [
          EVENT_TYPES.availableShift,
          EVENT_TYPES.pending,
          EVENT_TYPES.leave,
          EVENT_TYPES.unavailability,
        ],
      },
      myLocations: 'manager',
      noForeignPersonas: true,
      isCalendar: true,
      hideShiftsActions: true, // undo, redo, create shifts buttons
    },
    {
      label: 'Unavailability',
      value: 'availability',
      isCalendar: true,
      myLocations: 'manager',
      noForeignPersonas: true,
      hideShiftsActions: true, // undo, redo, create shifts buttons
    },
    {
      label: 'Experimental',
      value: 'experimental',
      isCalendar: true,
    },
  ],
};

export const displayModes = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
};

export const OPTIONS_FILTER_PROPERTIES = [
  { name: 'showEmptyRows' },
  { name: 'showLaborCost' },
  { name: 'showProjectedSales' },
  { name: 'showCountOfHours' },
  {
    name: 'showPlanningEvents',
    processEvents: true,
  },
  { name: 'showLaborPercentage' },
  {
    name: 'showForeignShifts',
    processEvents: true,
  },
];

export const DEFAULT_FILTER_EXPANSION = {
  locationsFiltersExpanded: true,
  positionsFiltersExpanded: true,
  eventsFiltersExpanded: true,
  optionsFiltersExpanded: true,
  tagsFiltersExpanded: false,
};

export const EDUCATION_STEPS = {
  CREATE_SHIFT: 'CREATE_SHIFT',
  SAVE_NEW_SHIFT: 'SAVE_NEW_SHIFT',
  UNPUBLISHED_SHIFT_CREATED: 'UNPUBLISHED_SHIFT_CREATED',
  PUBLISH_SCHEDULE: 'PUBLISH_SCHEDULE',
  FIELDS_VISIBILITY_BUTTONS: 'FIELDS_VISIBILITY_BUTTONS',
  SHIFT_THREE_DOT_OPTIONS: 'SHIFT_THREE_DOT_OPTIONS',
};

export const TOAST_EDUCATION_STEPS = {
  TOAST_IMPORT_SHIFT_UNDO: 'TOAST_IMPORT_SHIFT_UNDO',
  TOAST_IMPORT_SHIFT_COPY: 'TOAST_IMPORT_SHIFT_COPY',
  TOAST_IMPORT_SHIFT_PUBLISH: 'TOAST_IMPORT_SHIFT_PUBLISH',
};

export const DAY_UNIT = 'DAYS';

export const SALES_IMPORT_ALIGNMENT = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
};

export const REQUIRES_ACCEPTANCE_MESSAGE = "The shift will be yours if it's accepted by a manager";

export const SHIFT_AUTOMATICALLY_APPROVED_HEADER = 'You have a new shift';
export const SHIFT_AUTOMATICALLY_APPROVED_MESSAGE = 'Your shift application has been approved';

export const TIMEOFF_DURATION_MODES = [
  { value: false, label: 'Full day' },
  { value: true, label: 'Partial day' },
];

export const MAX_RECURRENCE_YEARS = 1;
export const NO_GROUP_FILTER_OPTION_ID = 'noGroups';
export const NO_TAG_FILTER_OPTION_ID = 'noTags';
export const NO_LOCATION_FILTER_OPTION_ID = 'noLocations';
export const NO_POSITION_FILTER_OPTION_ID = 'noPositions';
export const OTHER_DAY_PART_FILTER_OPTION_ID = 'otherDayPart';

export const RESOLVE_SCHEDULE_CONFLICTS = {
  AVAILABLE: 'available',
  UNASSIGN: 'unassign',
  DELETE: 'delete',
};

export const TABS_NAME = {
  FULL_SCHEDULE: 'alllocations',
  MY_LOCATIONS: 'mylocations',
  MY_SCHEDULE: 'myschedule',
};

export const LOGS_TYPES = {
  NOTE_UPDATED: 'assignee_notes_updated',
};

export const STICKY_CONTAINER_ID = 'shifts-sticky-container-holder';
export const STICKY_CONTAINER_FOR_COLUMN_CLONE_ID = 'shifts-sticky-container-column-clone-holder';
export const STICKY_COLUMN_CLONE_CLASS = 'shifts-sticky-user-column-clone';
